// extracted by mini-css-extract-plugin
export default {"info":"Warning_info__Q90zn"};